module.exports = __webpack_public_path__ + "static/robothor-modular-2377ef08cddfa2028882eac99e221f29.gif";